// extracted by mini-css-extract-plugin
module.exports = {"title":"NotFound_title__2vVlt","content":"NotFound_content__31gnC","imageContainer":"NotFound_imageContainer__2xuh9","descriptionContainer":"NotFound_descriptionContainer__1uvtQ"};